import { QueryCache, MutationCache, QueryClient } from '@tanstack/react-query';
import { handleApiError } from './utils/handleApiError';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => { handleApiError(error, { queryClient }); },
  }),
  mutationCache: new MutationCache({
    onError: (error) => { handleApiError(error, { queryClient }); },
  }),
});

export default queryClient;
